window.env = window.env || {};

export const STORMCROW_HOST =
  window.env.REACT_APP_STORMCROW_HOST ||
  process.env.REACT_APP_STORMCROW_HOST ||
  'http://localhost:4100';
export const MITHRANDIR_URL =
  window.env.REACT_APP_MITHRANDIR_URL ||
  process.env.REACT_APP_MITHRANDIR_URL ||
  'http://localhost:1892';
export const PADAWAN_HOST =
  window.env.REACT_APP_PADAWAN_HOST ||
  process.env.REACT_APP_PADAWAN_HOST ||
  'http://localhost:9901';
export const KAZAAM_HOST =
  window.env.REACT_APP_KAZAAM_HOST ||
  process.env.REACT_APP_KAZAAM_HOST ||
  'http://localhost:9100';
export const USE_SECURE_COOKIES =
  (window.env.REACT_APP_USE_SECURE_COOKIES ||
    process.env.REACT_APP_USE_SECURE_COOKIES ||
    'false') === 'true';
export const LOAD_EXTERNAL_SCRIPTS =
  window.env.REACT_APP_LOAD_EXTERNAL_SCRIPTS ||
  process.env.REACT_APP_LOAD_EXTERNAL_SCRIPTS ||
  'false';
export const BUGSNAG_API_KEY =
  window.env.REACT_APP_BUGSNAG_API_KEY ||
  process.env.REACT_APP_BUGSNAG_API_KEY ||
  'fake';
export const APP_VERSION =
  window.env.REACT_APP_VERSION || process.env.REACT_APP_VERSION || '1';
